import React, { useContext } from 'react';
import { Button, Grid } from '@mui/material';
import { WindowContext } from 'contexts/WindowContext';

const ViewPoolButton = ({ onClick }) => {
    const { isMobile } = useContext(WindowContext);
    return (
        <Grid
            item
            sx={{
                flexGrow: 1,
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                alignSelf: 'flex-end',
                textAlign: 'end'
            }}
            md={3}
            sm={6}
            xs={6}
        >
            <Button variant="contained" size={isMobile ? 'small' : 'medium'} onClick={onClick} sx={{ minWidth: '100px' }}>
                View Pool
            </Button>
        </Grid>
    );
};

export default ViewPoolButton;
